import React from 'react';
import {
  BarChart,
  PieChart,
  Bar,
  Pie,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';
import './NuevoDashboard.css';

const COLORS = ['#28a745', '#3a2c91', '#6c757d', '#00D8FE', '#ffc107'];

const DashboardRecharts = ({ 
  dataVentasDia, 
  dataMediosPago, 
  dataSucursales,
  idSucursal,
  fechaInicio,
  fechaBusqueda,
  handleSucursalChange,
  handleFechaBusquedaChange,
  handleFechaBusquedaChangeInicio
}) => {
  const ventasData = dataVentasDia && dataVentasDia.length > 0 ? dataVentasDia[0] : null;
  const mediosPagoData = dataMediosPago && dataMediosPago.length > 0 ? dataMediosPago : [];
  
  const salesData = [
    { 
      metodo: 'Boletas', 
      ventas: ventasData ? parseFloat(ventasData.Boletas || 0) : 0,
      cantidad: ventasData ? parseInt(ventasData.CantidadBoletas || 0) : 0
    },
    { 
      metodo: 'Facturas', 
      ventas: ventasData ? parseFloat(ventasData.Facturas || 0) : 0,
      cantidad: ventasData ? parseInt(ventasData.CantidadFacturas || 0) : 0
    },
    { 
      metodo: 'Vales', 
      ventas: ventasData ? parseFloat(ventasData.Vales || 0) : 0,
      cantidad: ventasData ? parseInt(ventasData.CantidadVales || 0) : 0
    }
  ];

  const methodSales = mediosPagoData.length > 0 
    ? mediosPagoData.map(item => ({
        metodo: item.medio_pago,
        ventas: parseFloat(item.total_monto || 0),
        transacciones: parseInt(item.cantidad_transacciones || 0),
        promedio: parseFloat(item.monto_promedio || 0),
        porcentaje: parseFloat(item.porcentaje_participacion || 0),
        tipopago: item.id_tipo_pago,
        color: item.color_grafico,
        ranking: item.ranking_monto
      }))
    : [];

  const formatCurrency = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? '0.00' : num.toFixed(2);
  };

  const totalVentas = salesData.reduce((sum, item) => sum + item.ventas, 0).toFixed(2);
  const totalCantidad = salesData.reduce((sum, item) => sum + item.cantidad, 0);
  const totalMedioPago = methodSales.reduce((sum, item) => sum + item.ventas, 0).toFixed(2);
  const totalTransacciones = methodSales.reduce((sum, item) => sum + item.transacciones, 0);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      
      {/* Filtros de Fecha y Sucursal */}
      <div style={{ 
        border: '1px solid #01a59c',
        backgroundColor: '#dbedec',
        padding: '15px', 
        borderRadius: '1.25rem', 
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div className="row">
          <div className="col-md-3 mb-2">
            <label className="form-label"><strong>Fecha Inicio:</strong></label>
            <input
              name="fechaInicio"
              className="form-control"
              onChange={handleFechaBusquedaChangeInicio}
              value={fechaInicio || ''}
              type="date"
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className="col-md-3 mb-2">
            <label className="form-label"><strong>Fecha Fin:</strong></label>
            <input
              name="fechaFin"
              className="form-control"
              onChange={handleFechaBusquedaChange}
              value={fechaBusqueda || ''}
              type="date"
              max={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div className="col-md-6 mb-2">
            <label className="form-label"><strong>Sucursal:</strong></label>
            <select
              className="form-control"
              name="sucursal"
              value={idSucursal || ""}
              onChange={handleSucursalChange}
            >
              <option value="">Sucursal actual</option>
              {dataSucursales && dataSucursales.map(sucursal => (
                <option
                  key={sucursal.IdSucursal}
                  value={sucursal.IdSucursal}
                  title={sucursal.Nombre}
                >
                  {sucursal.Nombre}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Resumen de Medios de Pago */}
      <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', marginBottom: '20px' }}>
        <h4 className='text-center'>Resumen de Medios de Pago</h4>
  
        {methodSales.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
            {methodSales.map((item, index) => (
              <div key={index} style={{ 
                flex: '1', 
                minWidth: '180px', 
                padding: '10px', 
                backgroundColor: 'white', 
                borderRadius: '5px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                borderLeft: `4px solid ${item.color}`
              }}>
                <h5 style={{ margin: '0 0 5px 0', color: item.color }}>
                  {item.metodo}
                </h5>
                <p style={{ margin: '0', fontSize: '14px' }}>
                  <strong>Monto:</strong> S/ {formatCurrency(item.ventas)}
                </p>
                <p style={{ margin: '0', fontSize: '14px' }}>
                  <strong>Transacciones:</strong> {item.transacciones}
                </p>
                <p style={{ margin: '0', fontSize: '12px', color: '#666' }}>
                  Ranking: #{item.ranking}
                </p>
              </div>
            ))}
            <div style={{
              flex: '1',
              minWidth: '180px',
              padding: '10px',
              backgroundColor: '#e9ecef',
              borderRadius: '5px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              borderLeft: '4px solid #6c757d'
            }}>
              <h5 style={{ margin: '0 0 5px 0'}}>TOTALES</h5>
              <p><strong>Monto:</strong> S/ {formatCurrency(totalMedioPago)}</p>
              <p><strong>Transacciones:</strong> {totalTransacciones}</p>
            </div>
          </div>
        ) : (
          <div style={{ 
            textAlign: 'center', 
            padding: '20px', 
            backgroundColor: 'white', 
            borderRadius: '5px',
            color: '#6c757d'
          }}>
            <p>No hay datos de medios de pago para mostrar</p>
          </div>
        )}
      </div>

      {/* Gráficos */}
      <div style={{ display: 'flex', width: "100%", marginBottom: '30px', gap: '20px', flexWrap: 'wrap' }}>
        
        <div style={{ flex: '1 1 48%', minWidth: '300px', marginBottom: '30px' }}>
          <h3>Ventas por Medio de Pago</h3>
          {methodSales.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={methodSales}
                layout="vertical"
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis 
                  type="number" 
                  tickFormatter={(value) => `S/ ${value}`}
                />
                <YAxis type="category" dataKey="metodo" />
                <Tooltip 
                  formatter={(value) => [`S/ ${formatCurrency(value)}`, 'Monto Total']}
                />
                <Legend />
                <Bar dataKey="ventas" name="Ventas S/">
                  {methodSales.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div style={{ 
              height: '300px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: '#f8f9fa',
              borderRadius: '5px',
              color: '#6c757d'
            }}>
              No hay datos para el gráfico
            </div>
          )}
        </div>

        <div style={{ flex: '1 1 48%', minWidth: '300px', marginBottom: '30px' }}>
          <h3>Distribución Porcentual</h3>
          {methodSales.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={methodSales}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  innerRadius={50}
                  dataKey="ventas"
                  nameKey="metodo"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(1)}%`}
                  labelLine={false}
                >
                  {methodSales.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip 
                  formatter={(value, name, props) => [
                    `S/ ${formatCurrency(value)} (${props.payload.porcentaje || 0}%)`, 
                    props.payload.metodo
                  ]} 
                />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div style={{ 
              height: '300px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: '#f8f9fa',
              borderRadius: '5px',
              color: '#6c757d'
            }}>
              No hay datos para el gráfico
            </div>
          )}
        </div>
      </div>

      {/* Resumen de Ventas por Documento */}
      <div style={{ 
        backgroundColor: '#f8f9fa', 
        padding: '15px', 
        borderRadius: '5px',
        marginBottom: '20px'
      }}>
        <h4 className='text-center'>Resumen de Ventas por Documento</h4>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
          {salesData.map((item, index) => (
            <div key={index} style={{ 
              flex: '1', 
              minWidth: '150px', 
              padding: '10px', 
              backgroundColor: 'white', 
              borderRadius: '5px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <h5 style={{ margin: '0 0 5px 0', color: COLORS[index % COLORS.length] }}>
                {item.metodo}
              </h5>
              <p style={{ margin: '0', fontSize: '14px' }}>
                Monto: S/ {item.ventas.toFixed(2)}
              </p>
              <p style={{ margin: '0', fontSize: '14px' }}>
                Cantidad: {item.cantidad}
              </p>
            </div>
          ))}
          <div style={{
            flex: '1',
            minWidth: '150px',
            padding: '10px',
            backgroundColor: '#e9ecef',
            borderRadius: '5px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            <h5 style={{ margin: '0 0 5px 0'}}>TOTALES</h5>
            <p>Monto: S/ {totalVentas}</p>
            <p>Cantidad: {totalCantidad}</p>
          </div>
        </div>
      </div>

      {/* Gráfico de Ventas por Tipo de Documento */}
      <div style={{ 
        flex: '1 1 100%', 
        marginBottom: '30px' 
      }}>
        <h3>Ventas por Tipo de Documento</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={salesData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="metodo" />
            <YAxis tickFormatter={(value) => `S/ ${value}`}/>
            <Tooltip 
              formatter={(value, name) => {
                const labelMap = {
                  'ventas': `S/ ${value.toFixed(2)}`,
                  'cantidad': value
                };
                const nameMap = {
                  'ventas': 'Monto',
                  'cantidad': 'Cantidad'
                };
                
                return [labelMap[name] || value, nameMap[name] || name];
              }}
            />
            <Legend />
            <Bar dataKey="ventas" fill="#01a59c" name="Monto (S/)" />
            <Bar dataKey="cantidad" fill="#8884d8" name="Cantidad" />
          </BarChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
};

export default DashboardRecharts;